export enum YesNo {
  yes = 'yes',
  no = 'no',
}
